import React, { Component } from "react";
import Grid from '@mui/material/Grid';
import SpinnerModal from "@components/SpinnerModal";
import DropDownMenu from "@components/DropDownMenu";
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import { useDialog } from 'react-st-modal';
import styles from './updatepermissiondialog.module.css';
import SupportAlert from '@components/SupportAlert';
import TextField from '@mui/material/TextField';
import FieldValidator from '@components/FieldValidator';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Switch from '@mui/material/Switch';

class UpdatePermissionDialog extends Component {
    state = {
        loading: false,

        permissionName: '',
        permissionDescription: '',
        permissionResource: '',
        permissionAction: '',
        permissionActive: false,

        validPermissionName: true,
        validPermissionResource: true,
        validPermissionDescription: true,
        validPermissionAction: true,
        validPermissionActive: true,

        resourceOptions: [],
        
        selectedPermission: null,
        permissionActions: [
            { value: 'CREATE', label: 'CREATE' },
            { value: 'DELETE', label: 'DELETE' },
            { value: 'UPDATE', label: 'UPDATE' },
            { value: 'VIEW', label: 'VIEW' }
        ],
    }

    async componentDidMount() {
        this.setState({ loading: true });
     
        await this.reloadResourceOptions();

        this.setState({ selectedPermission: this.props.permission });

        this.setState({ permissionActive: this.props.permission.active });
        this.setState({ permissionAction: this.props.permission.action });
        this.setState({ permissionName: this.props.permission.name });
        this.setState({ permissionDescription: this.props.permission.description });
        this.setState({ permissionResource: this.props.permission.resource });

        this.setState({ loading: false });
    }

    async reloadResourceOptions() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemPermissions = await RolePermissionManagementService.getRdiSystemPermissions();
                let resourceOptions = [];

                systemPermissions.forEach(systemPermission => {
                    if (!resourceOptions.some(resource => (resource.value === systemPermission.resource))) {
                        resourceOptions.push({ value: systemPermission.resource, label: systemPermission.resource });
                    }
                });

                this.setState({ resourceOptions: resourceOptions });

            } catch (ex) {
                console.log('Network error loading system permissions');
            }
        })([]);

        this.setState({ loading: false });
    }

    handleChangedValue = (evt) => {
        switch (evt.target.name) {
            case 'permissionName': {
                this.setState({ validPermissionName: (evt.target.value !== undefined && evt.target.value !== null && evt.target.value.trim() !== '') });
                this.setState({ permissionName: evt.target.value.toUpperCase() });
                break;
            }
            case 'resource': {
                this.setState({ validPermissionResource: (evt.target.value !== undefined && evt.target.value !== null && evt.target.value.trim() !== '') });
                this.setState({ permissionResource: evt.target.value });
                break;
            }
            case 'description': {
                this.setState({ validPermissionDescription: (evt.target.value !== undefined && evt.target.value !== null && evt.target.value.trim() !== '') });
                this.setState({ permissionDescription: evt.target.value });
                break;
            }
            case 'permission_action': {
                this.setState({ validPermissionAction: (evt.target.value !== undefined && evt.target.value !== null) });
                this.setState({ permissionAction: evt.target.value.toUpperCase() });
                break;
            }
            case 'permission_active': {
                const newValue = !this.state.permissionActive;
                this.setState({ validPermissionActive: true });
                this.setState({ permissionActive: newValue });
                break;
            }
            default: {
                break;
            }
        }
    }

    getData() {

        let data = {
            actionById: this.props.surveysUserId,
            rdiPermission: {
                id: this.props.permission.id,
                name: this.state.permissionName,
                description: this.state.permissionDescription,
                resource: this.state.permissionResource,
                action: this.state.permissionAction,
                active: this.state.permissionActive
            }
        };

        return data;

    }

    dialogBody() {

        return <div className={styles.flex_row_container}>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Current Permission"}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={true}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'permissionName'}
                                        type="text"
                                        placeholder={'Name'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'Name'}
                                        required
                                        value={this.props.permission.name.toUpperCase()}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        />
                                </Grid>
                                <Grid container item xs={6} >
                                    <TextField
                                        disabled={true}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'permissionName'}
                                        type="text"
                                        placeholder={'Permission Name'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'Resource'}
                                        required
                                        value={this.props.permission.resource.toUpperCase()}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>

                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={true}
                                        name={'description'}
                                        className={styles.dialogInputs}
                                        id="outlined-multiline-static"
                                        label="Description"
                                        multiline
                                        rows={4}
                                        placeholder={'Ipsum lorem ..'}
                                        defaultValue=" "
                                        required
                                        value={this.props.permission.description}
                                    />
                                </Grid>
                                <Grid container item xs={6} >
                                    <TextField
                                        disabled={true}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'permissionAction'}
                                        type="text"
                                        placeholder={'Action'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'System Action'}
                                        required
                                        value={this.props.permission.action.toUpperCase()}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <br /><br />
                                    <div>
                                        <FormControl>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        disabled={true}
                                                        name={'permission_active'}
                                                        size='small'
                                                        color='primary'
                                                        sx={{ m: 1 }}
                                                        checked={(this.props.permission.active)}
                                                    />
                                                }
                                                label={this.props.permission.active ? "Active" : "Disabled"}
                                            />
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>
            </div>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Updated Permission"}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={this.props.actionDelete === true}
                                        error={this.state.permissionName > 0 && !this.state.validPermissionName}
                                        helperText={!FieldValidator.validateName(this.state.permissionName) ? 'Invalid Permission Name' : null}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'permissionName'}
                                        type="text"
                                        placeholder={'Permission Name'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'Name'}
                                        required
                                        value={this.state.permissionName.toUpperCase()}
                                        onChange={this.handleChangedValue}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid container item xs={6} >
                                    <DropDownMenu
                                        name={'permission_action'}
                                        label={'System Action'}
                                        value={this.state.permissionAction}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                        showKeys={false}
                                        menuOptions={this.state.permissionActions.sort((a, b) => a.value > b.value ? 1 : -1)}
                                        placeholder='Select Action'
                                        required
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>

                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        name={'description'}
                                        className={styles.dialogInputs}
                                        error={this.state.permissionDescription.length > 0 && !this.state.validPermissionDescription}
                                        helperText={!this.state.validPermissionDescription ? 'Description cannot be empty' : null}
                                        id="outlined-multiline-static"
                                        label="Description"
                                        multiline
                                        rows={4}
                                        placeholder={'Ipsum lorem ..'}
                                        defaultValue=" "
                                        required
                                        value={this.state.permissionDescription}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                    />
                                </Grid>
                                <Grid container item xs={6} >
                                    <DropDownMenu
                                        name={'resource'}
                                        label={'Resource'}
                                        value={this.state.permissionResource}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                        showKeys={false}
                                        menuOptions={this.state.resourceOptions.sort((a, b) => a.value > b.value ? 1 : -1)}
                                        placeholder='Select Resource'
                                        required
                                    />
                                    <br /><br />
                                    <div>
                                        <FormControl>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        name={'permission_active'}
                                                        size='small'
                                                        color='primary'
                                                        sx={{ m: 1 }}
                                                        checked={(this.state.permissionActive)}
                                                        onChange={(evt) => {
                                                            this.handleChangedValue(evt)
                                                        }}
                                                    />
                                                }
                                                label={this.state.permissionActive ? "Active" : "Disabled"}
                                            />
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>
            </div>
        </div>
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Dialog loading ...'} />
        } else {
            return <DialogWrapper
                {...this.props}
                onClick={(evt) => this.props.nextButton.onClick(evt, this.getData())}
                validDetails={(this.state.validPermissionName === true) &&
                    (this.state.validPermissionResource === true) &&
                    (this.state.validPermissionDescription === true) &&
                    (this.state.validPermissionAction === true) &&
                    (this.state.validPermissionActive === true)}
                content={
                    <React.Fragment>
                        {this.dialogBody()}
                    </React.Fragment>
                }
            />
        }
    }

}
export default UpdatePermissionDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            if (!props.validDetails) {
                                SupportAlert.displayAlert('Updating permission failed', 'Please review supplied information carefully.');
                            } else {
                                props.onClick(evt);
                                dialog.close(true);
                            }
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

